export default __webpack_public_path__ + "static/media/techspec-power-station.5145face.png";